exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-action-button[data-v-af6f0c98] {\n  width: 48px;\n}\n@media screen and (min-width: 768px) {\n.horizontal-button[data-v-af6f0c98] {\n    display: flex;\n    flex-direction: row !important;\n    justify-content: space-around !important;\n    align-items: center;\n    width: auto !important;\n    padding: 0 15px;\n}\n.horizontal-button .card-action-text[data-v-af6f0c98] {\n    font-size: 14px;\n    padding: 0 0 0 5px;\n    margin: 0;\n}\n}", ""]);

// exports
